import { QueryClient } from "@tanstack/react-query";
import { mutationCache } from "./mutationCache";

export const queryClient = new QueryClient({
  mutationCache,
});
